// extracted by mini-css-extract-plugin
module.exports = {"loading":"_22LIP"};